import { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useFormik } from "formik";
import { useLocation } from "react-router-dom";
import { DefaultSwrOptions, StorageKey } from "../../constants/constants";
import { GetContact, GetCurpRfc, CreateContact, UpdateContact, GetPastores, GetIglesias, GetPastoresData } from "../../service/odoo";
import Breadcrumb from "../../components/Breadcrumb";
import SweetAlertModal from "../../components/dialogs/SweetAlertModal";
import PropTypes from 'prop-types';
import ReactSelect from 'react-select';
import Async, { useAsync } from 'react-select/async';
import AsyncSelect from 'react-select/async';

import {
    Alert,
    Box,
    Button,
    Card,
    CardContent,
    FormLabel,
    Stack,
    TextField,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Avatar,
    Typography,
    MenuItem,
    Select,
    InputLabel,
    FormControl,
    ListItemText,
    Tab,
    Tabs,
    InputAdornment
} from "@mui/material";
import { GoogleMap, Marker, useLoadScript } from "@react-google-maps/api";
import { GetItem } from "utils/storage";

import * as Yup from "yup";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
const MySwal = withReactContent(Swal);

export default function MembersForm() {
    const [loadingSubmit, setLoadingSubmit] = useState(false);
    const [loadingCurp, setLoadingCurp] = useState(true);
    const [loadingConyugue, setLoadingConyugue] = useState(true);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const [modalMatrimoniosOpen, setModalMatrimoniosOpen] = useState(false);
    const [modalCambioOpen, setModalCambioOpen] = useState(false);
    const [estadoCivil, setEstadoCivil] = useState('');
    const [isMarried, setIsMarried] = useState(false);
    const [newConyugue, setNewConyugue] = useState(false);
    const [contactResults, setContactResults] = useState([]);
    const [conyugueResults, setConyugueResults] = useState([]);
    const [pagination, setPagination] = useState({ total_records: 0, limit: 10, offset: 0 });
    const [conyuguePagination, setConyuguePagination] = useState({ total_records: 0, limit: 10, offset: 0 });
    const [showConyugueFields, setShowConyugueFields] = useState(false);
    const [showAdditionalFields, setShowAdditionalFields] = useState(false);
    const [metadata, setMetadata] = useState({});
    const [mapCenter, setMapCenter] = useState({ lat: 19.4326, lng: -99.1332 });
    const [addressInfo, setAddressInfo] = useState("");
    const [imagePreview, setImagePreview] = useState("");
    const [formType, setFormType] = useState("");
    const [suggestions, setSuggestions] = useState([]); // Para almacenar las sugerencias de direcciones
    const [showButtonSearch, setShowButtonSearch] = useState(true);
    const [contactId, setContactId] = useState(null);
    const [conyugue, setConyugue] = useState('');
    const [fotoConyugue, setFotoConyugue] = useState(null);
    const [grupos, setGrupos] = useState([]);
    const [pastorBautizo, setPastorBautizo] = useState('');
    const [pastorBautizoAguas, setPastorBautizoAguas] = useState('');
    const [pastorBautizoEspiritu, setPastorBautizoEspiritu] = useState('');
    const [pastores, setPastores] = useState([]);
    const [iglesias, setIglesias] = useState([]);
    const [casoIURD, setCasoIURD] = useState(false);
    const [pastorCaso, setPastorCaso] = useState('');
    const [iglesiaCaso, setIglesiaCaso] = useState('');
    const [iglesiaRegistro, setIglesiaRegistro] = useState('');
    const [iglesiaDestino, setIglesiaDestino] = useState('');
    const [contactoSelected, setContactoSelected] = useState('');
    const [pastoresAguas, setPastoresAguas] = useState([]);
    const [pastorTest, setPastorTest] = useState('');
    const [cambioOption, setCambioOption] = useState('');
    const [cambioJustify, setCambioJustify] = useState('');

    function CustomTabPanel(props) {
        const { children, value, index, ...other } = props;

        return (
            <div
                role="tabpanel"
                hidden={value !== index}
                id={`simple-tabpanel-${index}`}
                aria-labelledby={`simple-tab-${index}`}
                {...other}
            >
                {value === index && <Box sx={{ p: 3 }}>{children}</Box>}
            </div>
        );
    }

    CustomTabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    CustomTabPanel.propTypes = {
        children: PropTypes.node,
        index: PropTypes.number.isRequired,
        value: PropTypes.number.isRequired,
    };

    const [valBautismo, setValBautismo] = useState(0);

    function a11yProps(index) {
        return {
            id: `simple-tab-${index}`,
            'aria-controls': `simple-tabpanel-${index}`,
        };
    }

    const autocompleteService = useRef(null);
    const navigate = useNavigate();

    const locationForm = useLocation();
    useEffect(() => {
        const stateFormType = locationForm.state?.formType; // Desde el estado del navegador
        const storedFormType = localStorage.getItem('form_type'); // Desde localStorage
        setFormType(stateFormType || storedFormType || ""); // Priorizar el estado del navegador
    }, [locationForm]);

    const { isLoaded } = useLoadScript({
        googleMapsApiKey: "AIzaSyCX6EAuN8_TMLRvuoaeadnLGo9KEDW0Fpo",
        libraries: ["places"],
    });

    useEffect(() => {
        fetchMetadata();
        fetchPastores();
        fetchIglesias();
    }, []);

    const fetchMetadata = async () => {
        const user = await GetItem(StorageKey.USER);
        setMetadata(user.metadata);

        //FILTRA LOS GRUPOS QUE SE VAN A MOSTRAR
        //const keysToInclude = [2, 6, 7, 8, 11, 13, 45];
        //const result = keysToInclude.map(index => user.metadata.groups[index]);
        //setGrupos(result);
    };

    const validationSchema = Yup.object().shape({
        first_name: Yup.string().required("El nombre es requerido"),
        middle_name: Yup.string().required("El nombre es requerido"),
        last_name: Yup.string().required("El apellido es requerido"),
        email: Yup.string().email("Correo inválido"),
        mobile: Yup.string().matches(/^[0-9]+$/, "Solo se permiten números"),
        phone: Yup.string().matches(/^[0-9]+$/, "Solo se permiten números"),
        gender: Yup.string().required("Selecciona un género"),
        marital_status: Yup.string().required("Selecciona un estado civil"),
        birthdate_date: Yup.string().required("Fecha de nacimiento es requerido"),
        birth_state_id: Yup.string().required("Selecciona un estado de Nacimiento"),
    });

    const formik = useFormik({
        initialValues: {
            email: '',
            first_name: '',
            middle_name: '',
            last_name: '',
            phone: '',
            mobile: '',
            birthdate_date: '',
            birth_state_id: '',
            gender: '',
            curp: '',
            rfc: '',
            nationality: '',
            marital_status: '',
            occupation: '',
            address: {
                street: '',
                interior_number: '',
                street2: '',
                city: '',
                state_id: '',
                zip: '',
                country_id: '',
                partner_latitude: '',
                partner_longitude: '',
                place_id: '',
                full_address: '',
                reference: '',
            },
            church_id: '',
            pastor: '',
            groups: [],
            image_base64: "",
            form_type: formType,
            bautismos: {
                bautismo_aguas: {
                    fecha: '',
                    pastor_id: '',
                    pastor_name: '',
                    church_id: '',
                },
                bautismo_espiritu_santo: {
                    fecha: '',
                    pastor_id: '',
                    pastor_name: '',
                    church_id: '',
                },
            },
            matrimonio: {
                conyugue_exists: false,
                fecha: '',
                conyugue: {
                    conyugue_id: null,
                    conyugue_name: '',
                    conyugue_first_name: '',
                    conyugue_middle_name: '',
                    conyugue_last_name: '',
                    //conyugue_gender: '',
                    //conyugue_birthdate_date: '',
                    //conyugue_birth_state_id: '',
                    //conyugue_occupation: '',
                    //conyugue_educational_level: '',
                    //conyugue_mobile: '',
                },
                pastor_name: '', //En caso de haber casado en la IURD
                pastor_id: '',
                church_id: '',
                marital_status: '',
            },
            cambio_iglesia: {
                in_validation: false,
                church_id_origin: '',
                church_id_destiny: '',
                justification: '',
            }
        },
        enableReinitialize: true,
        validateOnChange: false,
        validateOnBlur: false,
        validationSchema,
        onSubmit: (values) => {

            if(!formik.values.matrimonio.conyugue_exists){
                delete values.matrimonio;
            }

            if(formik.values.bautismos.bautismo_aguas.fecha === '' && formik.values.bautismos.bautismo_espiritu_santo.fecha === ''){
                delete values.bautismos;
            }

            handleSubmit(values);
            console.log(values);
        }
    });

    /*useEffect(() => {
        if (formik.values.marital_status === "married") {
            setIsMarried(true);
            console.log("isMarried ", isMarried);
            setModalMatrimoniosOpen(true);
        } else {
            setIsMarried(false);
            cancelSelectConyugue();
        }
    }, [formik.values.marital_status]);*/


    const handleSubmit = async (values) => {
        console.log("++++++++++++++++");
        console.log(values);

        formik.setFieldValue("form_type", formType);

        const result = await MySwal.fire({
            title: "¿Estás seguro?",
            text: contactId
                ? "¿Quieres actualizar este contacto?"
                : "¿Quieres crear este nuevo contacto?",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Sí, continuar",
            cancelButtonText: "No, revisar",
        });

        if (!result.isConfirmed) {

            return;
        }

        setLoadingSubmit(true);

        if (contactId) {
            return UpdateContact({
                ...values,
            }, contactId).then(res => {
                if (res.status === 200) {
                    MySwal.fire({
                        title: "¡Registro exitoso!",
                        text: "El contacto ha sido actualizado exitosamente.",
                        icon: "success",
                        confirmButtonText: "Aceptar",
                    });
                    setSuccess("Contacto actualizado exitosamente!!");
                    handleCancelReset();
                } else if (res.status === 401) {
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: "Excedió el tiempo de la sesión.",
                        timer: 2000
                    });
                    navigate('/');
                } else {
                    setError(res.data);
                }
                setLoadingSubmit(false);
            });
        } else {
            // Crear contacto
            return CreateContact({
                ...values,
            }).then(res => {
                if (res.status === 200) {
                    MySwal.fire({
                        title: "¡Registro exitoso!",
                        text: "El contacto ha sido creado exitosamente.",
                        icon: "success",
                        confirmButtonText: "Aceptar",
                        timer: 2000,
                    });
                    setSuccess("Contacto creado exitosamente!!");
                    handleCancelReset();
                } else if (res.status === 401) {
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: "Excedió el tiempo de la sesión.",
                        timer: 2000
                    });
                    navigate('/');
                } else {
                    setError(res.data);
                }
                setLoadingSubmit(false);
            });
        }
    };


    const handleMapClick = (event) => {
        const lat = event.latLng.lat();
        const lng = event.latLng.lng();
        setMapCenter({ lat, lng });

        formik.setFieldValue("address.partner_latitude", lat);
        formik.setFieldValue("address.partner_longitude", lng);
    };

    const handleAddressInfoChange = (event) => {
        setAddressInfo(event.target.value);
        if (!autocompleteService.current && window.google) {
            autocompleteService.current = new window.google.maps.places.AutocompleteService();
        }
        if (autocompleteService.current) {
            autocompleteService.current.getPlacePredictions({ input: event.target.value }, (predictions) => {
                if (predictions) {
                    setSuggestions(predictions.map(prediction => ({
                        description: prediction.description,
                        placeId: prediction.place_id,
                    })));
                } else {
                    setSuggestions([]);
                }
            });
        }
    };

    const buildQueryParams = (params) => {
        return Object.keys(params)
            .filter(key => params[key]) // Solo incluir campos con valores
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`)
            .join("&");
    };

    const validateQueryParams = (params) => {
        const filteredParams = Object.keys(params)
            .filter(key => key !== "limit" && key !== "offset") // Excluir limit y offset
            .reduce((obj, key) => {
                obj[key] = params[key];
                return obj;
            }, {});

        const hasValues = Object.keys(filteredParams).some(key => filteredParams[key]);
        return hasValues;
    };

    const fetchContacts = async () => {
        try {
            const queryParams = {
                limit: pagination.limit,
                offset: pagination.offset,
                email: formik.values.email,
                first_name: formik.values.first_name,
                middle_name: formik.values.middle_name,
                last_name: formik.values.last_name,
                birthdate_date: formik.values.birthdate_date,
                phone: formik.values.phone,
                mobile: formik.values.mobile,
                nationality: formik.values.nationality,
            };

            if (!validateQueryParams(queryParams)) {
                Swal.fire({
                    icon: "error",
                    title: "Error",
                    text: "Debes completar al menos un campo para realizar la búsqueda.",
                    timer: 2000
                });
                return;
            }

            const finalQueryParams = buildQueryParams(queryParams)
            setLoadingSubmit(true);
            GetContact(finalQueryParams).then(res => {
                if (res.status === 200 && res.data.data.length) {
                    setIglesiaDestino(metadata.churches[0].id);
                    setSuccess('Contacto encontrado exitosamente');
                    setContactResults(res.data.data);
                    setPagination(res.data.pagination);
                    setModalOpen(true);
                    setShowAdditionalFields(false);
                } else if (res.status === 401) {
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: "Excedió el tiempo de la sesión.",
                        timer: 2000
                    });
                    navigate('/');
                } else {
                    setError("No se encontraron contactos.");
                    /*formik.setValues({
                        ...formik.values,
                        church_id: metadata.churches[0].id,
                    });*/
                    setIglesiaDestino(metadata.churches[0].id);
                    setShowAdditionalFields(true);
                }

            });

        } catch (err) {
            setError("Error al buscar el contacto.");
        }
    };

    const fetchConyugue = async () => {
        try {
            console.log("Conyugue: ", conyugue);
            const queryParams = {
                limit: pagination.limit,
                offset: pagination.offset,
                first_name: conyugue,
            };

            const finalQueryParams = buildQueryParams(queryParams)
            GetContact(finalQueryParams).then(res => {
                if (res.status === 200 && res.data.data.length) {
                    console.log("Conyugue encontrado: ", res.data.data);

                    //setSuccess('Conyugue encontrado exitosamente');
                    setConyugueResults(res.data.data);
                    setConyuguePagination(res.data.pagination);
                    setLoadingConyugue(false);
                    //setModalOpen(true);
                    //setShowAdditionalFields(false);
                } else {
                    setError("No se encontró conyugue.");
                    //setShowAdditionalFields(true);
                }

            });

        } catch (err) {
            setError("Error al buscar el contacto.");
        }
    };

    const handleSearchContact = () => {
        setPagination(prev => ({ ...prev, offset: 0 })); // Reinicia el offset al realizar una nueva búsqueda
        fetchContacts();
    };

    const handleSearchConyugue = () => {
        setPagination(prev => ({ ...prev, offset: 0 })); // Reinicia el offset al realizar una nueva búsqueda
        fetchConyugue();
    };

    const handlePreviousPage = () => {
        if (pagination.offset > 0) {
            setPagination((prev) => ({ ...prev, offset: prev.offset - pagination.limit }));
        }
    };

    const handleNextPage = () => {
        if (pagination.offset + pagination.limit < pagination.total_records) {
            setPagination((prev) => ({ ...prev, offset: prev.offset + pagination.limit }));
        }
    };

    const handleCurpRfcChange = () => {
        try {
            const [year, month, day] = formik.values.birthdate_date.split('-');
            const nuevaFecha = `${day}-${month}-${year}`;
            const genero = formik.values.gender === 'male' ? 'H' : 'M';
            const queryParams = buildQueryParams({
                first_name: formik.values.first_name,
                last_name: formik.values.middle_name,
                middle_name: formik.values.last_name,
                birthdate_date: nuevaFecha,
                gender: genero,
                birth_state_id: formik.values.birth_state_id
            });
            GetCurpRfc(queryParams).then(res => {
                if (res) {
                    console.log(res.data);
                    console.log(res.data.data.curp);
                    console.log(res.data.data.rfc);
                    formik.setFieldValue("curp", res.data.data.curp);
                    formik.setFieldValue("rfc", res.data.data.rfc)
                } else {
                    setError("No se generó RFC ni Curp");
                    //setShowAdditionalFields(true);
                }

            });

        } catch (err) {
            setError("Error al generar RFC y CURP.");
        }
    }

    const handleRfcChange = () => {

    }

    const handleBautismoChange = (event, newValue) => {
        setValBautismo(newValue);
    };

    useEffect(() => {
        if (modalOpen) {
            fetchContacts();
        }
    }, [pagination.offset]);

    useEffect(() => {
        if (modalMatrimoniosOpen) {
            fetchConyugue();
        }
    }, [pagination.offset]);

    const handleSelectContact = (contact) => {
        formik.setValues({
            ...formik.values,
            first_name: contact.first_name || "",
            middle_name: contact.middle_name || "",
            last_name: contact.last_name || "",
            gender: contact.gender || "",
            birthdate_date: contact.birthdate_date || "",
            phone: contact.phone || "",
            email: contact.email || "",
            mobile: contact.mobile || "",
            nationality: contact.nationality || "",
            marital_status: contact.marital_status || "",
            occupation: contact.occupation || "",
            address: contact.address || {},
            church_id: contact.church?.id || "",
            pastor: contact.pastor?.id || "",
            groups: contact.groups?.map(group => group.id) || [],
            birth_state_id: contact.birth_state_id || "",
        });
        if (contact.image_url) setImagePreview(contact.image_url)
        
        //console.log(metadata.churches[0].id);

        if (contact.church?.id !== metadata.churches[0].id) {
            formik.setFieldValue("church_id", metadata.churches[0].id);
            setIglesiaRegistro(metadata.churches[0].name);
            setIglesiaDestino(metadata.churches[0].id);
            setModalCambioOpen(true);
        }

        setContactoSelected(contact);
        console.log("Contacto seleccionado: ", contact);
        setModalOpen(false);
        setModalMatrimoniosOpen(false);
        //setModalCambioOpen(false);
        setShowAdditionalFields(true);
        setShowButtonSearch(false)
        setContactId(contact.id)
        setLoadingSubmit(false)
    };

    const handleSelectSuggestion = async (suggestion) => {
        setAddressInfo(suggestion.description);
        const geocoder = new window.google.maps.Geocoder();
        const { results } = await geocoder.geocode({ placeId: suggestion.placeId });
        if (results[0]) {
            const location = results[0].geometry.location;
            setMapCenter({ lat: location.lat(), lng: location.lng() });
            geocodeLatLng(location.lat(), location.lng());
        }
        setSuggestions([]);
    };

    const handleSelectConyugue = (contact) => {
        formik.setValues({
            ...formik.values,
            matrimonio: {
                conyugue_exists: true,
                conyugue: {
                    conyugue_id: contact.id || null,
                    conyugue_first_name: contact.first_name || "",
                    conyugue_middle_name: contact.middle_name || "",
                    conyugue_last_name: contact.last_name || "",
                    conyugue_birthdate_date: contact.birthdate_date || "",
                    conyugue_gender: contact.gender || "",
                    conyugue_birth_state_id: contact.birth_state_id || "",
                    conyugue_occupation: contact.occupation || "",
                    conyugue_educational_level: contact.educational_level || "",
                    conyugue_mobile: contact.mobile || "",
                }
            }
        });
        if (contact.image_url) setFotoConyugue(contact.image_url)
        setModalOpen(false);
        //setModalMatrimoniosOpen(false);
        setShowConyugueFields(true);
        console.log("id conyugue ", contact.id);
    };

    const handlePastorCaso = (pastor) => {
        console.log("Pastor Caso: ", pastor);

        formik.setValues({
            ...formik.values,

        });
    };

    const geocodeLatLng = async (lat, lng) => {
        const geocoder = new window.google.maps.Geocoder();
        const { results } = await geocoder.geocode({ location: { lat, lng } });
        if (results[0]) {
            const addressComponents = results[0].address_components;
            const formattedAddress = results[0].formatted_address;
            formik.setFieldValue("address.full_address", formattedAddress);
            formik.setFieldValue("address.partner_latitude", lat);
            formik.setFieldValue("address.partner_longitude", lng);

            // Extrae la información de dirección relevante y actualiza los campos
            addressComponents.forEach((component) => {
                const componentType = component.types[0];
                switch (componentType) {
                    case "street_number":
                        formik.setFieldValue("address.interior_number", component.long_name);
                        break;
                    case "route":
                        formik.setFieldValue("address.street", component.long_name);
                        break;
                    case "locality":
                        formik.setFieldValue("address.city", component.long_name);
                        break;
                    case "administrative_area_level_1":
                        formik.setFieldValue("address.state_id", component.long_name);
                        break;
                    case "postal_code":
                        formik.setFieldValue("address.zip", component.long_name);
                        break;
                    case "country":
                        formik.setFieldValue("address.country_id", component.long_name);
                        break;
                    default:
                        break;
                }
            });
        }
    };

    useEffect(() => {
        // Verifica si todos los campos están llenos
        if (formik.values.first_name && formik.values.middle_name && formik.values.last_name && formik.values.birthdate_date && formik.values.birthdate_date
            && formik.values.birth_state_id && formik.values.gender) {
            handleCurpRfcChange();
        }
    }, [formik.values.first_name, formik.values.middle_name, formik.values.last_name, formik.values.birthdate_date, formik.values.birthdate_date
        , formik.values.birth_state_id, formik.values.gender]);

    const handleImageChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result.split(",")[1];
                formik.setFieldValue("image_base64", base64String);
                setImagePreview(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const cancelSelectContact = () => {
        setShowAdditionalFields(true);
        setModalOpen(false)
        setShowButtonSearch(false)
        setLoadingSubmit(false)
    }
    const handleCancelReset = () => {
        formik.resetForm();
        setShowButtonSearch(true);
        setLoadingSubmit(true);
        setShowAdditionalFields(false);
        setError(null);
        setSuccess(null);
    }

    useEffect(() => {
        formik.setFieldValue("marital_status", estadoCivil);
    }, [estadoCivil]);

    const cancelSelectConyugue = () => {
        formik.setValues({
            ...formik.values,
            matrimonio: {
                conyugue: {
                    conyugue_id: null,
                    conyugue_first_name: "",
                    conyugue_middle_name: "",
                    conyugue_last_name: ""
                }
            },
            //if
            marital_status: estadoCivil,
        });
        //setShowAdditionalFields(true);
        setModalMatrimoniosOpen(false);
        setShowConyugueFields(false);
        //setShowButtonSearch(false)
        setLoadingConyugue(true);
    }

    const pastoresBaut = [
        { value: 1, label: "Allan Montero" },
        { value: 2, label: "Prueba Varios" },
        { value: 3, label: "Pastor3" }
    ]

    const handleChurchChange = (church) => {

        console.log("Iglesia: ", church);

        /*let iglesia = metadata.churches.find(item => item.id === church);

        setIglesiaRegistro(iglesia.name);
        setIglesiaDestino(church);
        if (church !== contactoSelected.church?.id) {
            console.log("Cambio de iglesia");
            console.log("Iglesia: ", church);
            console.log("Iglesia Registro: ", contactoSelected.church?.id);
            setModalCambioOpen(true);
        }*/
    }

    const handleCambio = (option) => {
        setCambioOption(option);
        console.log("Cambio: ", option);
    }

    const handleConfirmaCambio = () => {
        setModalCambioOpen(false);
        //setIglesiaRegistro()

        if (cambioOption === "1") {
            console.log(cambioOption);
            console.log("Iglesia Destino: ", contactoSelected.church?.id);
            formik.setValues({
                ...formik.values,
                church_id: contactoSelected.church?.id,
                cambio_iglesia: {
                    in_validation: false,
                    church_id_origin: contactoSelected.church.id,
                    church_id_destiny: contactoSelected.church.id,
                }
            });
            /*formik.setFieldValue(church_id, contactoSelected.church?.id);
            formik.setFieldValue(cambio_iglesia, {
                in_validation: false,
                church_id_origin: contactoSelected.church?.id,
                church_id_destiny: contactoSelected.church?.id,
            });*/

            //console.log("Formik: ", formik.values);
        } else if (cambioOption === "2") {
            console.log(cambioOption);
            console.log("Iglesia Destino: ", iglesiaDestino);
            formik.setValues({
                ...formik.values,
                church_id: iglesiaDestino,
                cambio_iglesia: {
                    in_validation: true,
                    church_id_origin: contactoSelected.church?.id,
                    church_id_destiny: iglesiaDestino,
                }
            });
        }

        


        /*formik.setValues({
            ...formik.values,
            church_id: iglesiaDestino,
            cambio_iglesia: {
                in_validation: true,
                church_id_origin: contactoSelected.church?.id,
                church_id_destiny: iglesiaDestino,
            }
        });*/
    }

    const cancelCambioIglesia = () => {
        setModalCambioOpen(false);
        //setIglesiaDestino('');
    }

    const fetchPastores = async () => {
        try {
            GetPastores().then(res => {
                if (res.status === 200 && res.data.data.length) {

                    //setSuccess('Pastores encontrados exitosamente');
                    setPastores(res.data.data);
                } else if (res.status === 401) {
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: "Excedió el tiempo de la sesión.",
                        timer: 2000
                    });
                    navigate('/');
                } else {
                    setError("No se encontraron pastores.");
                    setShowAdditionalFields(true);
                }

            });
        } catch (err) {
            setError("Error al buscar los pastores.");
            console.log(err);
        }
    }

    const fetchIglesias = async () => {
        try {
            GetIglesias().then(res => {
                if (res.status === 200 && res.data.data.length) {

                    //setSuccess('Iglesias encontrados exitosamente');
                    setIglesias(res.data.data);
                } else if (res.status === 401) {
                    Swal.fire({
                        icon: "error",
                        title: "Error",
                        text: "Excedió el tiempo de la sesión.",
                        timer: 2000
                    });
                    navigate('/');
                } else {
                    setError("No se encontraron Iglesias.");
                    setShowAdditionalFields(true);
                }

            });
        } catch (err) {
            setError("Error al buscar los Iglesias.");
            console.log(err);
        }
    }

    const pastoresBautismo = pastores.map(item => ({
        value: item.id,
        label: item.name,
    }));

    const iglesiasMatrimonio = iglesias.map(item => ({
        value: item.id,
        label: item.name + " - " + item.alias,
        alias: item.alias,
        code_church: item.code_church,
    }));

    const handlePastorAguas = (pastor) => {
        setPastorBautizoAguas(pastor);

        formik.values.bautismos.bautismo_aguas.pastor_id = pastor.value;
        formik.values.bautismos.bautismo_aguas.pastor_name = pastor.label;

    };

    const handlePastorEspiritu = (pastor) => {
        setPastorBautizoEspiritu(pastor);

        formik.values.bautismos.bautismo_espiritu_santo.pastor_id = pastor.value;
        formik.values.bautismos.bautismo_espiritu_santo.pastor_name = pastor.label;

    };

    const handlePastorAguasFetch = (pastor) => {
        console.log("Pastor Aguas: ", pastor);

        const queryParams = {
            name: pastor
        };

        const finalQueryParams = buildQueryParams(queryParams)
        try {
            GetPastoresData(finalQueryParams).then(res => {
                if (res.status === 200 && res.data.data.length) {

                    //setSuccess('Pastores encontrados exitosamente');
                    console.log("Pastores Aguas: ", res.data.data);
                    setPastoresAguas(res.data.data);
                } else {
                    setError("No se encontraron pastores.");
                    //setShowAdditionalFields(true);
                }

            });
        } catch (err) {
            setError("Error al buscar los pastores.");
            console.log(err);
        }
    }

    useEffect(() => {
        console.log("Pastor Aguas: ", pastorTest);
        if (pastorTest !== '') {
            handlePastorAguasFetch(pastorTest);
        }
    }, [pastorTest]);


    // Función para cargar las opciones de pastores desde la API
    const loadPastores = async (inputValue) => {
        if (!inputValue) return [];
        try {
            const res = await GetPastoresData(`name=${inputValue}`);
            console.log("Response: ", res);

            if (res.status === 200 && res.data.data.length) {

                //setSuccess('Pastores encontrados exitosamente');
                console.log("Pastores Aguas: ", res.data.data);
                //setPastoresAguas(res.data.data); 
            } else {
                setError("No se encontraron pastores.");
            }
            const data = res.data.data;
            console.log("Data: ", data);
            // Mapeamos los resultados de la API al formato esperado por react-select
            return data.map((item) => ({
                value: item.id, // Valor único del item
                label: item.name, // Texto visible en el select
            }));
        } catch (error) {
            console.error("Error al cargar las opciones:", error);
            return [];
        }
    };

    const handleLoadPastores = (selectedOption) => {
        console.log("Opción seleccionada:", selectedOption);
        setPastorBautizoAguas(selectedOption);
        formik.setFieldValue("bautismos.bautismo_aguas.church_id", "" + metadata.churches[0].id);
        formik.setFieldValue("bautismos.bautismo_aguas.pastor_id", "" + selectedOption.value);
        formik.setFieldValue("bautismos.bautismo_aguas.pastor_name", selectedOption.label);
    };

    const handleLoadPastoresEspiritu = (selectedOption) => {
        console.log("Opción seleccionada Esp:", selectedOption);
        setPastorBautizoEspiritu(selectedOption);
        formik.setFieldValue("bautismos.bautismo_espiritu_santo.church_id", "" + metadata.churches[0].id);
        formik.setFieldValue("bautismos.bautismo_espiritu_santo.pastor_id", "" + selectedOption.value);
        formik.setFieldValue("bautismos.bautismo_espiritu_santo.pastor_name", selectedOption.label);
    };

    const handleEstadoCivil = (estadoCivil) => {
        //formik.setFieldValue("marital_status", estadoCivil);
        /*formik.setValues({
            ...formik.values,
            marital_status: estadoCivil
        });*/
        //setIsMarried(true);
        formik.setFieldValue("matrimonio.conyugue_exists", false);
        formik.setFieldValue("matrimonio.fecha", '');
        formik.setFieldValue("matrimonio.church_id", "1");
        formik.setFieldValue("matrimonio.pastor_id", "1");
        setEstadoCivil(estadoCivil);
        console.log("Estado Civil: ", estadoCivil);
        if (estadoCivil === 'married' || estadoCivil === 'engaged' || estadoCivil === 'free_union') {
            setModalMatrimoniosOpen(true);
            formik.setFieldValue("marital_status", estadoCivil);
        } else {
            formik.setFieldValue("marital_status", estadoCivil);
            //setIsMarried(false);
            setModalMatrimoniosOpen(false);
            cancelSelectConyugue();
            formik.setFieldValue("matrimonio.conyugue_exists", false);
            formik.setFieldValue("matrimonio.fecha", '');
        }
    }

    return (
        <>
            <Breadcrumb
                title={`Registro de ${formType}`}
                items={[
                    { to: '/app', title: 'Inicio' },
                    { title: formType },
                ]}
            />
            <Box sx={{ width: '100%' }}>
                <form onSubmit={formik.handleSubmit}>
                    <Stack spacing={3}>
                        <Card>
                            <CardContent>
                                {error && <Alert severity="error">{error}</Alert>}
                                {success && <Alert severity="success">{success}</Alert>}
                                <Grid container spacing={2}>

                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Foto</FormLabel>
                                        <Stack direction="row" alignItems="center" spacing={2}>
                                            <Avatar
                                                src={imagePreview || "/default-image.jpg"}
                                                alt="Previsualización"
                                                sx={{ width: 64, height: 64 }}
                                            />
                                            <Button variant="contained" component="label">
                                                Subir Foto
                                                <input
                                                    type="file"
                                                    hidden
                                                    accept="image/*"
                                                    onChange={handleImageChange}
                                                />
                                            </Button>
                                        </Stack>
                                    </Grid>

                                    {/* Campos de búsqueda */}
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Nombre(s)</FormLabel>
                                        <TextField
                                            fullWidth
                                            name="first_name"
                                            onChange={formik.handleChange}
                                            value={formik.values.first_name}
                                            error={formik.touched.first_name && Boolean(formik.errors.first_name)}
                                            helperText={formik.touched.first_name && formik.errors.first_name}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Apellido Paterno</FormLabel>
                                        <TextField
                                            fullWidth
                                            name="middle_name"
                                            onChange={formik.handleChange}
                                            value={formik.values.middle_name}
                                            error={formik.touched.middle_name && Boolean(formik.errors.middle_name)}
                                            helperText={formik.touched.middle_name && formik.errors.middle_name}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Apellido Materno</FormLabel>
                                        <TextField
                                            fullWidth
                                            name="last_name"
                                            onChange={formik.handleChange}
                                            value={formik.values.last_name}
                                            error={formik.touched.last_name && Boolean(formik.errors.last_name)}
                                            helperText={formik.touched.last_name && formik.errors.last_name}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Correo</FormLabel>
                                        <TextField
                                            fullWidth
                                            name="email"
                                            onChange={formik.handleChange}
                                            value={formik.values.email}
                                            error={formik.touched.email && Boolean(formik.errors.email)}
                                            helperText={formik.touched.email && formik.errors.email}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Teléfono</FormLabel>
                                        <TextField
                                            fullWidth
                                            name="phone"
                                            onChange={formik.handleChange}
                                            value={formik.values.phone}
                                            error={formik.touched.phone && Boolean(formik.errors.phone)}
                                            helperText={formik.touched.phone && formik.errors.phone}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Móvil</FormLabel>
                                        <TextField
                                            fullWidth
                                            name="mobile"
                                            onChange={formik.handleChange}
                                            value={formik.values.mobile}
                                            error={formik.touched.mobile && Boolean(formik.errors.mobile)}
                                            helperText={formik.touched.mobile && formik.errors.mobile}
                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormLabel>Fecha de Nacimiento</FormLabel>
                                        <TextField
                                            fullWidth
                                            name="birthdate_date"
                                            onChange={formik.handleChange}
                                            value={formik.values.birthdate_date}
                                            type="date"
                                            error={formik.touched.birthdate_date && Boolean(formik.errors.birthdate_date)}
                                            helperText={formik.touched.birthdate_date && formik.errors.birthdate_date}

                                        />
                                    </Grid>
                                    <Grid item xs={12} md={6}>
                                        <FormControl fullWidth>
                                            <InputLabel>Estado de Nacimiento</InputLabel>
                                            <Select
                                                name="birth_state_id"
                                                value={formik.values.birth_state_id}
                                                onChange={formik.handleChange}
                                                error={formik.touched.birth_state_id && Boolean(formik.errors.birth_state_id)}
                                                helperText={formik.touched.birth_state_id && formik.errors.birth_state_id}
                                            >
                                                {metadata.states?.map(state => (
                                                    <MenuItem key={state.id} value={state.id}>
                                                        {state.name}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </FormControl>
                                    </Grid>
                                    {showButtonSearch && (
                                        <Grid item xs={12} spacing={3}>
                                            <Button onClick={handleSearchContact} variant="contained">
                                                Buscar
                                            </Button>
                                        </Grid>
                                    )}

                                    {showAdditionalFields && (
                                        <>
                                            {/* Campos adicionales para crear/actualizar */}

                                            <Grid item xs={12} md={6}>
                                                <FormControl fullWidth>
                                                    <InputLabel>Género</InputLabel>
                                                    <Select
                                                        name="gender"
                                                        value={formik.values.gender}
                                                        onChange={formik.handleChange}
                                                        error={formik.touched.gender && Boolean(formik.errors.gender)}
                                                        helperText={formik.touched.gender && formik.errors.gender}
                                                    >
                                                        <MenuItem value="male">Masculino</MenuItem>
                                                        <MenuItem value="female">Femenino</MenuItem>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <FormControl fullWidth>
                                                    <InputLabel>Estado Civil</InputLabel>
                                                    <Select
                                                        name="marital_status"
                                                        value={formik.values.marital_status}
                                                        onChange={(event)=> {
                                                            //formik.setFieldValue("marital_status", event.target.value);
                                                            handleEstadoCivil(event.target.value);
                                                        }}
                                                    >
                                                        {metadata.marital_status?.map(status => (
                                                            <MenuItem key={status.value} value={status.value}>
                                                                {status.spanish}
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                                
                                            </Grid>

                                            {(showConyugueFields && (

                                                <Grid item xs={12} md={6}>
                                                    <FormControl fullWidth>
                                                        <FormLabel>Conyugue</FormLabel>
                                                        <TextField
                                                            name="conyugue"
                                                            onChange={formik.handleChange}
                                                            disabled
                                                            InputProps={{
                                                                startAdornment: (
                                                                    <InputAdornment position="start">
                                                                        <Box display="flex" alignItems="center" gap={1}>
                                                                            <Avatar src={fotoConyugue} alt={formik.values.matrimonio.conyugue.conyugue_first_name} sx={{ width: 24, height: 24 }} />
                                                                            <Typography>{formik.values.matrimonio.conyugue.conyugue_first_name + " " + formik.values.matrimonio.conyugue.conyugue_middle_name + " " + formik.values.matrimonio.conyugue.conyugue_last_name}</Typography>
                                                                        </Box>
                                                                    </InputAdornment>
                                                                )
                                                            }}
                                                        >

                                                        </TextField>

                                                        <Button onClick={() => setModalMatrimoniosOpen(true)} variant="contained">
                                                            Editar
                                                        </Button>
                                                    </FormControl>
                                                </Grid>

                                            ))}

                                            <Grid item xs={12} md={6}>
                                                <FormControl fullWidth>
                                                    <InputLabel>Grupos</InputLabel>
                                                    <Select
                                                        name="groups"
                                                        multiple
                                                        value={formik.values.groups}
                                                        onChange={formik.handleChange}
                                                        renderValue={(selected) => selected.map(id => metadata.groups?.find(group => group.id === id)?.name).join(", ")}
                                                    >
                                                        {metadata.groups?.map(group => (
                                                            <MenuItem key={group.id} value={group.id}>
                                                                <ListItemText primary={group.name} />
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <FormControl fullWidth>
                                                    <InputLabel>Iglesia</InputLabel>
                                                    <Select
                                                        name="church_id"
                                                        value={formik.values.church_id}
                                                        onChange={formik.handleChange}
                                                    >
                                                        {cambioOption === "1" ? (
                                                            iglesias
                                                                .filter(church => church.id === contactoSelected.church?.id)
                                                                .map(church => (
                                                                    <MenuItem key={church.id} value={church.id}>
                                                                        {church.name}
                                                                    </MenuItem>
                                                                ))
                                                        ) : 
                                                            iglesias
                                                                    .filter(church => church.id === iglesiaDestino)
                                                                    .map(church => (
                                                                        <MenuItem key={church.id} value={church.id}>
                                                                            {church.name}
                                                                        </MenuItem>
                                                                    ))
                                                        }
                                                        
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            {/*console.log("Formik: ", formik.values)*/}
                                            <Grid item xs={12} md={6}>
                                                <FormControl fullWidth>
                                                    <InputLabel>Pastor</InputLabel>
                                                    <Select
                                                        name="pastor"
                                                        value={formik.values.pastor}
                                                        onChange={formik.handleChange}
                                                        renderValue={(selected) => {
                                                            const pastor = metadata.pastors?.find(p => p.id === selected);
                                                            return pastor ? (
                                                                <Stack direction="row" spacing={1} alignItems="center">
                                                                    <Avatar src={pastor.photo_url} alt={pastor.name} sx={{ width: 24, height: 24 }} />
                                                                    <Typography>{pastor.name}</Typography>
                                                                </Stack>
                                                            ) : "";
                                                        }}
                                                    >
                                                        {metadata.pastors?.map(pastor => (
                                                            <MenuItem key={pastor.id} value={pastor.id}>
                                                                <Stack direction="row" spacing={1} alignItems="center">
                                                                    <Avatar src={pastor.photo_url} alt={pastor.name} sx={{ width: 24, height: 24 }} />
                                                                    <ListItemText primary={pastor.name} />
                                                                </Stack>
                                                            </MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                            </Grid>

                                            <Grid item xs={12} md={6}>

                                                <Box sx={{ width: '100%' }}>
                                                    <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                                                        <Tabs value={valBautismo} onChange={handleBautismoChange} aria-label="basic tabs example">
                                                            <Tab label="BAUTISMO EN LAS AGUAS" {...a11yProps(0)} />
                                                            <Tab label="BAUTISMO EN EL ESPÍRITU SANTO" {...a11yProps(1)} />
                                                        </Tabs>
                                                    </Box>
                                                    <CustomTabPanel value={valBautismo} index={0}>
                                                        <InputLabel>Fecha de bautismo en las aguas</InputLabel>
                                                        {formik.values.bautismos ? (
                                                        <TextField
                                                            fullWidth
                                                            name="bautismos.bautismo_aguas.fecha"
                                                            onChange={formik.handleChange}
                                                            value={formik.values.bautismos.bautismo_aguas.fecha}
                                                            type="date"
                                                        />) :(
                                                            <p></p>
                                                        )}

                                                        <InputLabel>Pastor que bautizó</InputLabel>
                                                        <FormControl fullWidth>
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={loadPastores}
                                                                defaultOptions
                                                                onChange={handleLoadPastores}
                                                                value={pastorBautizoAguas}
                                                                placeholder="Selecciona un pastor"
                                                            />
                                                            {pastores
                                                                .filter(pastor => pastor.name === pastorBautizoAguas.label)
                                                                .map(pastor => (
                                                                    <MenuItem key={pastor.id} value={pastor.id}>
                                                                        <Stack direction="row" spacing={1} alignItems="center">
                                                                            <Avatar src={pastor.photo_url} alt={pastor.name} sx={{ width: 24, height: 24 }} />
                                                                            <ListItemText primary={pastor.name} />
                                                                        </Stack>
                                                                    </MenuItem>

                                                                ))}
                                                        </FormControl>


                                                    </CustomTabPanel>
                                                    <CustomTabPanel value={valBautismo} index={1}>
                                                        <InputLabel>Fecha de bautismo en el Espíritu Santo</InputLabel>

                                                        {formik.values.bautismos ? (
                                                        <TextField
                                                            fullWidth
                                                            name="bautismos.bautismo_espiritu_santo.fecha"
                                                            onChange={formik.handleChange}
                                                            value={formik.values.bautismos.bautismo_espiritu_santo.fecha}
                                                            type="date"
                                                        />) :(
                                                            <p></p>
                                                        )}

                                                        <InputLabel>Pastor que bautizó</InputLabel>
                                                        <FormControl fullWidth>
                                                            <AsyncSelect
                                                                cacheOptions
                                                                loadOptions={loadPastores}
                                                                defaultOptions
                                                                onChange={handleLoadPastoresEspiritu}
                                                                value={pastorBautizoEspiritu}
                                                                placeholder="Selecciona un pastor"
                                                            />
                                                            {pastores
                                                                .filter(pastor => pastor.name === pastorBautizoEspiritu.label)
                                                                .map(pastor => (
                                                                    <MenuItem key={pastor.id} value={pastor.id}>
                                                                        <Stack direction="row" spacing={1} alignItems="center">
                                                                            <Avatar src={pastor.photo_url} alt={pastor.name} sx={{ width: 24, height: 24 }} />
                                                                            <ListItemText primary={pastor.name} />
                                                                        </Stack>
                                                                    </MenuItem>

                                                                ))}
                                                        </FormControl>
                                                    </CustomTabPanel>
                                                </Box>
                                            </Grid>


                                            {/* Dirección y mapa */}
                                            {/* Campos de búsqueda */}
                                            <Grid item xs={12}>
                                                <FormLabel>Dirección</FormLabel>
                                                <TextField
                                                    fullWidth
                                                    name="address_info"
                                                    onChange={handleAddressInfoChange}
                                                    value={addressInfo}
                                                    placeholder="Ingresa una dirección"
                                                />
                                                {suggestions.length > 0 && (
                                                    <Box sx={{ border: '1px solid #ccc', borderRadius: 2, maxHeight: 150, overflowY: 'auto', mt: 1 }}>
                                                        {suggestions.map((suggestion, index) => (
                                                            <Box
                                                                key={index}
                                                                sx={{ padding: 1, cursor: 'pointer', '&:hover': { backgroundColor: '#f0f0f0' } }}
                                                                onClick={() => handleSelectSuggestion(suggestion)}
                                                            >
                                                                {suggestion.description}
                                                            </Box>
                                                        ))}
                                                    </Box>
                                                )}
                                            </Grid>
                                            <Grid item xs={12} md={12}>
                                                {isLoaded ? (
                                                    <GoogleMap
                                                        center={mapCenter}
                                                        zoom={15}
                                                        mapContainerStyle={{ width: '100%', height: '400px' }}
                                                        onClick={handleMapClick}
                                                    >
                                                        <Marker position={mapCenter} />
                                                    </GoogleMap>
                                                ) : (
                                                    <p>Cargando mapa...</p>
                                                )}
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    fullWidth
                                                    name="address.street"
                                                    label="Calle"
                                                    onChange={formik.handleChange}
                                                    value={formik.values.address.street}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    fullWidth
                                                    name="address.interior_number"
                                                    label="Número Interior"
                                                    onChange={formik.handleChange}
                                                    value={formik.values.address.interior_number}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    fullWidth
                                                    name="address.city"
                                                    label="Ciudad"
                                                    onChange={formik.handleChange}
                                                    value={formik.values.address.city}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    fullWidth
                                                    name="address.state_id"
                                                    label="Estado"
                                                    onChange={formik.handleChange}
                                                    value={formik.values.address.state_id}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    fullWidth
                                                    name="address.zip"
                                                    label="Código Postal"
                                                    onChange={formik.handleChange}
                                                    value={formik.values.address.zip}
                                                />
                                            </Grid>
                                            <Grid item xs={12} md={6}>
                                                <TextField
                                                    fullWidth
                                                    name="address.reference"
                                                    label="Referencia"
                                                    onChange={formik.handleChange}
                                                    value={formik.values.address.reference}
                                                />
                                            </Grid>
                                        </>
                                    )}
                                </Grid>
                            </CardContent>
                        </Card>
                        <Stack direction="row" justifyContent="space-between">
                            <Button
                                color="secondary"
                                variant="outlined"
                                onClick={handleCancelReset}
                            >
                                Cancelar
                            </Button>
                            <Button
                                color="primary"
                                variant="contained"
                                type="submit"

                            >
                                {contactId ? "Actualizar" : "Registrar"}
                            </Button>
                        </Stack>
                    </Stack>
                </form>
            </Box>

            {/* Modal para seleccionar el contacto */}
            <Dialog open={modalOpen} onClose={() => setModalOpen(false)} fullWidth maxWidth="md">
                <DialogTitle>Seleccionar Contacto</DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        {contactResults.map((contact) => (
                            <Grid item xs={12} sm={6} md={4} key={contact.id}>
                                <Card onClick={() => handleSelectContact(contact)}>
                                    <CardContent>
                                        <Avatar src={contact.image_url || "/default-image.jpg"} sx={{ width: 60, height: 60, marginBottom: 1 }} />
                                        <Typography variant="h6">{contact.first_name + " " + contact.middle_name + " " + contact.last_name || "Sin Nombre"}</Typography>
                                        <ul>
                                            <li>Iglesia:{contact.church?.name || ""}</li>
                                            <li>Correo:{contact.email || ""}</li>
                                            <li>Estado civil:{contact.marital_status || ""}</li>
                                            <li>Edad:{contact.age || ""}</li>

                                        </ul>
                                    </CardContent>
                                </Card>
                            </Grid>
                        ))}
                    </Grid>
                </DialogContent>
                <DialogActions
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "16px", // Espaciado opcional
                    }}
                >
                    {/* Botón alineado a la izquierda */}
                    <Box>
                        <Button onClick={cancelSelectContact} variant="outlined" color="error">
                            Cancelar y crear contacto
                        </Button>
                    </Box>

                    {/* Botones alineados a la derecha */}
                    <Box sx={{ display: "flex", gap: "8px" }}>
                        <Button
                            onClick={handlePreviousPage}
                            disabled={pagination.offset === 0}
                            variant="contained"
                        >
                            Página Anterior
                        </Button>
                        <Button
                            onClick={handleNextPage}
                            disabled={
                                pagination.offset + pagination.limit >= pagination.total_records
                            }
                            variant="contained"
                        >
                            Página Siguiente
                        </Button>
                        <Button
                            onClick={() => setModalOpen(false)}
                            color="primary"
                            variant="contained"
                        >
                            Confirmar
                        </Button>
                    </Box>
                </DialogActions>

            </Dialog>

            {/* Modal para seleccionar el conyugue */}
            <Dialog open={modalMatrimoniosOpen} onClose={() => setModalMatrimoniosOpen(false)} fullWidth maxWidth="md">
                <DialogTitle>Buscar conyugue</DialogTitle>
                <DialogContent>

                    <Grid container spacing={2}>
                        <Grid item xs={12} spacing={3}>
                            <InputLabel>Verificar Nombre del Conyugue</InputLabel>
                            <TextField
                                fullWidth
                                name="matrimonio.conyugue_name"
                                value={conyugue}
                                onChange={e => setConyugue(e.target.value)}
                                type="text"
                            />
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} >
                        <Grid item xs={12} spacing={3} sx={{ marginTop: 2 }}>
                            <Button onClick={handleSearchConyugue} variant="contained">
                                Buscar
                            </Button>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} sx={{ marginTop: 2 }}>
                        {!loadingConyugue ? (
                            <Grid container spacing={2}>
                                {conyugueResults.map((contact) => (
                                    <Grid item xs={12} sm={6} md={4} key={contact.id}>
                                        <Card onClick={() => handleSelectConyugue(contact)}>
                                            <CardContent>
                                                <Avatar src={contact.image_url || "/default-image.jpg"} sx={{ width: 60, height: 60, marginBottom: 1 }} />
                                                <Typography variant="h6">{contact.first_name + " " + contact.middle_name + " " + contact.last_name || "Sin Nombre"}</Typography>
                                                <ul>
                                                    <li>Iglesia:{contact.church?.name || ""}</li>
                                                    <li>Correo:{contact.email || ""}</li>
                                                    <li>Estado civil:{contact.marital_status || ""}</li>
                                                    <li>Edad:{contact.age || ""}</li>

                                                </ul>
                                            </CardContent>
                                        </Card>
                                    </Grid>
                                ))}
                            </Grid>
                        ) :
                            (<p>Cargando...</p>)}
                    </Grid>

                    
                    <Grid item xs={12} md={6}>
                        <FormLabel>Nombre(s)</FormLabel>
                        {formik.values.matrimonio ? (
                        <TextField
                            fullWidth
                            name="matrimonio.conyugue.conyugue_first_name"
                            onChange={formik.handleChange}
                            value={formik.values.matrimonio.conyugue.conyugue_first_name}
                            type="text"
                        />) : (
                            <p></p>
                        )}
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <FormLabel>Apellido Paterno</FormLabel>
                        {formik.values.matrimonio ? (
                        <TextField
                            fullWidth
                            name="matrimonio.conyugue.conyugue_middle_name"
                            onChange={formik.handleChange}
                            value={formik.values.matrimonio.conyugue.conyugue_middle_name}
                            type="text"
                        />) : (
                            <p></p>
                        )}
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <FormLabel>Apellido Materno</FormLabel>
                        {formik.values.matrimonio ? (
                        <TextField
                            fullWidth
                            name="matrimonio.conyugue.conyugue_last_name"
                            onChange={formik.handleChange}
                            value={formik.values.matrimonio.conyugue.conyugue_last_name}
                            type="text"
                        />) : (
                            <p></p>
                        )}
                    </Grid>

                    {/*

                    <Grid item xs={12} md={6}>
                        <FormLabel>Móvil</FormLabel>
                        {formik.values.matrimonio ? (
                        <TextField
                            fullWidth
                            name="matrimonio.conyugue.conyugue_mobile"
                            onChange={formik.handleChange}
                            value={formik.values.matrimonio.conyugue.conyugue_mobile}
                            type="text"

                        />) : (
                            <p></p>
                        )}
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <InputLabel>Género</InputLabel>
                        {formik.values.matrimonio ? (
                        <Select
                            name="matrimonio.conyugue.conyugue_gender"
                            value={formik.values.matrimonio.conyugue.conyugue_gender}
                            onChange={formik.handleChange}
                            fullWidth
                        >
                            <MenuItem value="male">Masculino</MenuItem>
                            <MenuItem value="female">Femenino</MenuItem>
                        </Select>) : (
                            <p></p>
                        )}
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <FormLabel>Fecha de Nacimiento</FormLabel>
                        {formik.values.matrimonio ? (
                        <TextField
                            fullWidth
                            name="matrimonio.conyugue.conyugue_birthdate_date"
                            onChange={formik.handleChange}
                            value={formik.values.matrimonio.conyugue.conyugue_birthdate_date}
                            type="date"

                        />) : (
                            <p></p>
                        )}
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <InputLabel>Estado de Nacimiento</InputLabel>
                        {formik.values.matrimonio ? (
                        <Select
                            name="matrimonio.conyugue.conyugue_birth_state_id"
                            value={formik.values.matrimonio.conyugue.conyugue_birth_state_id}
                            onChange={formik.handleChange}
                            fullWidth
                        >
                            {metadata.states?.map(state => (
                                <MenuItem key={state.id} value={state.id}>
                                    {state.name}
                                </MenuItem>
                            ))}
                        </Select>) : (
                            <p></p>
                        )}
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <FormLabel>Ocupación</FormLabel>
                        {formik.values.matrimonio ? (
                        <TextField
                            fullWidth
                            name="matrimonio.conyugue.conyugue_occupation"
                            onChange={formik.handleChange}
                            value={formik.values.matrimonio.conyugue.conyugue_occupation}
                            type="text"

                        />) : (
                            <p></p>
                        )}
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <FormLabel>Nivel de estudios</FormLabel>
                        {formik.values.matrimonio ? (
                        <TextField
                            fullWidth
                            name="matrimonio.conyugue.conyugue_educational_level"
                            onChange={formik.handleChange}
                            value={formik.values.matrimonio.conyugue.conyugue_educational_level}
                            type="text"

                        />) : (
                            <p></p>
                        )}
                    </Grid>
                    
                    */}

                    <Grid item xs={12} md={6}>
                        <Typography variant="h6">Datos de Matrimonio</Typography>
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <FormLabel>Fecha de Matrimonio</FormLabel>
                        {formik.values.matrimonio ? (
                        <TextField
                            fullWidth
                            name="matrimonio.fecha"
                            onChange={formik.handleChange}
                            value={formik.values.matrimonio.fecha}
                            type="date"

                        />) : (
                            <p></p>
                        )}
                    </Grid>

                    <Grid item xs={12} md={6}>
                        <InputLabel>¿Casó en la IURD?</InputLabel>
                        <Select
                            name="wedding_iurd"
                            value={casoIURD}
                            onChange={e => setCasoIURD(e.target.value)}
                            fullWidth
                        >
                            <MenuItem value={true}>Sí</MenuItem>
                            <MenuItem value={false}>No</MenuItem>
                        </Select>
                    </Grid>

                    {casoIURD && (
                        <>
                            <Grid item xs={12} md={6}>
                                <InputLabel>Pastor que casó</InputLabel>
                                <ReactSelect
                                    options={pastoresBautismo}
                                    value={pastorCaso}
                                    onChange={(pastorCaso) => setPastorCaso(pastorCaso)}
                                    placeholder="Selecciona un pastor"
                                />
                            </Grid>

                            <Grid item xs={12} md={6}>
                                <InputLabel>Iglesia donde casó</InputLabel>
                                <ReactSelect
                                    options={iglesiasMatrimonio}
                                    value={iglesiaCaso}
                                    onChange={(iglesiaCaso) => setIglesiaCaso(iglesiaCaso)}
                                    placeholder="Selecciona una iglesia"
                                />
                            </Grid>
                        </>
                    )}

                </DialogContent>
                <DialogActions
                    sx={{
                        display: "flex",
                        justifyContent: "space-between",
                        padding: "16px", // Espaciado opcional
                    }}
                >
                    {/* Botón alineado a la izquierda */}
                    <Box>
                        <Button onClick={cancelSelectConyugue} variant="outlined" color="error">
                            Cancelar
                        </Button>
                    </Box>

                    {/* Botones alineados a la derecha */}
                    <Box sx={{ display: "flex", gap: "8px" }}>
                        <Button
                            onClick={handlePreviousPage}
                            disabled={pagination.offset === 0}
                            variant="contained"
                        >
                            Página Anterior
                        </Button>
                        <Button
                            onClick={handleNextPage}
                            disabled={
                                pagination.offset + pagination.limit >= pagination.total_records
                            }
                            variant="contained"
                        >
                            Página Siguiente
                        </Button>
                        <Button
                            onClick={() => setModalMatrimoniosOpen(false)}
                            color="primary"
                            variant="contained"
                        >
                            Confirmar
                        </Button>
                    </Box>
                </DialogActions>

            </Dialog>

            {/* Modal para confirmar cambio de iglesia */}
            <Dialog open={modalCambioOpen} onClose={() => setModalCambioOpen(false)} fullWidth maxWidth="md">
                <DialogTitle>CAMBIO DE IGLESIA</DialogTitle>
                <DialogContent>

                    <Grid container spacing={2} justifyContent="center" >
                        <Grid item textAlign="center" >
                            <Typography variant="h4" >{contactoSelected?.first_name} ya está registrado en otra iglesia:</Typography>
                            <Typography variant="h6">{contactoSelected.church?.name}</Typography>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} justifyContent="center" >
                        <Grid item textAlign="center" >
                            <p></p>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} justifyContent="center" >
                        <Grid item textAlign="center" >
                            <Typography variant="h4" >¿Qué opción deseas solicitar en la iglesia de:</Typography>
                            <Typography variant="h6">{iglesiaRegistro}?</Typography>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} justifyContent="center" >
                        <Grid item textAlign="center" >
                            <p></p>
                        </Grid>
                    </Grid>

                    <Grid container spacing={2} justifyContent="center" >
                        <Grid item xs={12} textAlign="center" >
                            <FormControl fullWidth>
                                <InputLabel>Selecciona una opción</InputLabel>
                                <Select
                                    name="church_option"
                                    value={cambioOption}
                                    onChange={event=> setCambioOption(event.target.value)}
                                >
                                    <MenuItem value="1">BAUTISMO - SIN CAMBIO DE IGLESIA</MenuItem>
                                    <MenuItem value="2">BAUTISMO - CON CAMBIO DE IGLESIA</MenuItem>
                                    <MenuItem value="3">CAMBIO DE IGLESIA</MenuItem>
                                    <MenuItem value="4">OTRO</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>

                    <Grid container>
                        <Grid item xs={12}>
                            <InputLabel>Justificación</InputLabel>
                            <TextField
                                fullWidth
                                name="cambio_iglesia.justification"
                                onChange={(event) => setCambioJustify(event.target.value)}
                                value={cambioJustify}
                                type="text"
                            />
                        </Grid>
                    </Grid>

                </DialogContent>
                <DialogActions
                    sx={{
                        display: "flex",
                        justifyContent: "space-evenly",
                    }}
                >
                    {/* Botón alineado a la izquierda */}
                    <Box>
                        <Button onClick={cancelCambioIglesia} variant="outlined" color="error">
                            Cancelar
                        </Button>
                    </Box>

                    {/* Botones alineados a la derecha */}
                    <Box sx={{ display: "flex" }}>
                        <Button
                            onClick={handleConfirmaCambio}
                            color="primary"
                            variant="contained"
                        >
                            Confirmar
                        </Button>
                    </Box>
                </DialogActions>

            </Dialog>
        </>
    );
}
